export function updateURLParameter(url: any, param: any, paramVal?: any){
    let newAdditionalURL = "";
    let tempArray = url.split("?");
    const baseURL = tempArray[0];
    let additionalURL = tempArray[1];
    let temp = '';
    if (additionalURL) {
        tempArray = additionalURL.split('&');
        for (let i=0; i<tempArray.length; i++){
            if(tempArray[i].split('=')[0] != param){
                newAdditionalURL += temp + tempArray[i];
                temp = '&';
            }
        }
    }
    let query = temp;
    if (typeof param === 'object') {
        for (let k in param) {
            query += k + '=' + param[k] + '&';
        }
        query = query.slice(0, -1);
    } else {
        query = param + '=' + paramVal;
    }

    return baseURL + '?' + newAdditionalURL + query;
}